import { useMemo } from 'react';

import { useAuth } from '../core/auth';
import { ANNOTATION_TOOL_ALLOWED_APPS, ANNOTATION_TOOL_ROLE_MAPPING } from '../lib';

/**
 * Custom hook to filter allowed apps based on user roles.
 * Only returns apps that the current user has permission to access.
 *
 * @returns Filtered array of allowed apps based on user roles
 */
export const useAnnotationToolAllowedApps = () => {
  const { user } = useAuth();
  const userRoleIds = useMemo(() => user.roles.map((role) => role.roleId), [user.roles]);

  return useMemo(() => {
    return ANNOTATION_TOOL_ALLOWED_APPS.filter((app) => {
      const requiredRole = ANNOTATION_TOOL_ROLE_MAPPING[app.appId];

      // If no role mapping exists, allow access (for backward compatibility)
      if (!requiredRole) {
        return true;
      }

      // Check if user has the required role (single or array)
      return Array.isArray(requiredRole)
        ? requiredRole.some((role) => userRoleIds.includes(role))
        : userRoleIds.includes(requiredRole);
    });
  }, [userRoleIds]);
};
